import type { CoverPageContent } from '@/blocks/domain/types/BlockContent/CoverPageContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';

export function mapCoverPageContent(dto: Extract<BlockContentDto, { kind: 'cover_page' }>): CoverPageContent {
  return {
    kind: 'cover_page',
    title: dto.title,
    showLogo: dto.show_logo,
    showCustomerName: dto.show_customer_name,
    showDate: dto.show_date
  };
}

export function fromCoverPageContent(content: CoverPageContent): Extract<BlockContentDto, { kind: 'cover_page' }> {
  return {
    kind: 'cover_page',
    title: content.title,
    show_logo: content.showLogo,
    show_customer_name: content.showCustomerName,
    show_date: content.showDate
  };
}
